/**
 * @generated SignedSource<<5ced530c982fd9691dbc3068d2cf1213>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenOwner_event$data = {
  readonly confirmedHosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly host: {
          readonly __typename: "Guild";
          readonly name: string;
          readonly primaryPhoto: {
            readonly rowId: string;
          } | null | undefined;
          readonly slugId: string;
          readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
        } | {
          readonly __typename: "User";
          readonly firstName: string;
          readonly lastName: string;
          readonly slugId: string;
          readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly id: string;
      } | null | undefined;
    }>;
  };
  readonly owner: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly primaryPhoto: {
      readonly rowId: string;
    } | null | undefined;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
  } | {
    readonly __typename: "User";
    readonly firstName: string;
    readonly lastName: string;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "EventScreenOwner_event";
};
export type EventScreenOwner_event$key = {
  readonly " $data"?: EventScreenOwner_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenOwner_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "primaryPhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GuildPrimaryPhotoNew_guild"
      }
    ],
    "type": "Guild",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserPrimaryPhotoNew_user"
      }
    ],
    "type": "User",
    "abstractKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenOwner_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventHostsConnection",
      "kind": "LinkedField",
      "name": "confirmedHosts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventHostsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventHost",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "host",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "a6705c5581c06a3cfde20045a4a099e8";

export default node;
